import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { AcquisitionContainerComponent } from "./containers/acquisition-container/acquisition-container.component";
import { LandTitleReportContainerComponent } from "./containers/land-title-report-container/land-title-report-container.component";

const routes: Routes = [
  { path: "", component: AcquisitionContainerComponent },
  { path: 'report', component: LandTitleReportContainerComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AcquisitionRoutingModule {}
